export const DRAWER_WIDTH = 300;
export const POLL_INTERVAL_MS = 30000;
export const INDIVIDUAL_POLL_INTERVAL_MS = 60000;
